<dx-button type="default" stylingMode="contained" [disabled]="!allowIntactSubmit" class="btn w-100" icon="fal fa-tags"
    [text]="caption" (click)="executeIntactRequest()">
</dx-button>